import Vue from "vue";
import Vuex from "vuex";

import appPackage from "../../package.json";

import Member from "./modules/member";
import Menu from "./modules/menu";
import Order from "./modules/order";
import Store from "./modules/store";

import mOrder from "@/modules/order";
import mMember from "@/modules/member";

import { APP_MODE } from "@/modules/enums";
import { ORDER_TYPE } from "@/modules/enums";

Vue.use(Vuex);

export default new Vuex.Store({
  components: {
    appPackage,
  },

  modules: {
    Member,
    Menu,
    Order,
    Store,
  },

  state: {
    isOffline: !navigator.onLine,

    httpReqOpt: { withCredentials: true },

    appPackage: appPackage,
    appSessionId: undefined,
    appSessionKey: undefined,
    appSessionIdModifiedTime: new Date(),
    appBar: {
      showDrawer: false,
    },
    appData: undefined,
    appToken: null,
    appTabBarIndex: 0,
    appInitialized: false,

    kernelNo: 246,

    testMode: false,
    testPhoneNo: "",

    membershipCardLogoSrc: null,

    phonePattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
    postalPattern: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
    emailPattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
    decimalPattern: /^(\d*\.)?\d{0,2}$/,
    numberPattern: /[+-]?\d+(?:\.\d+)?/g,
    //numberPattern: /^-?\\d*(\\.\\d+)?$/,
    //numberPattern: /^\d+$/,

    routeFrom: null,

    deviceInfo: null,

    launchTime: new Date(),

    rootName: null,

    companyName: "",
    service: null,
    myCoords: null,

    storeHours: null,

    serverBuildNo: 0,

    termsOfUseContent: null,

    doorDashTips: [
      {
        title: "10%",
        value: 10,
        rate: true,
        checked: false,
        other: false,
      },
      {
        title: "15%",
        value: 15,
        rate: true,
        checked: true,
        other: false,
      },
      {
        title: "20%",
        value: 20,
        rate: true,
        checked: false,
        other: false,
      },
      {
        title: "Other",
        value: 15,
        rate: true,
        checked: false,
        other: true,
      },
    ],

    descrIndex: 0,
    languages: [],
    languageSelected: null,

    member: null,
    guest: { name: "", phone1: "", phoneVerified: false },

    sideComboTags: [],
    addressList: [],

    orderHistory: [],

    headerHeight: 48,
    categoryBarHeight: 48,
    menuBarHeight: 48,

    theme: {
      primary: "#575761",
      secondary: "#648381",
      accent: "#cc4c7c",

      info: "#FFBF46",
      success: "#FFBF46",

      warning: "#c3073f",
      error: "#c3073f",

      primaryText: "#ffffff",
      secondaryText: "#ffffff",
      accentText: "#ffffff",
      infoText: "#000000",
      warningText: "#ffffff",
    },

    checkoutExpiryTimeout: null,

    // for force update
    cartKey: 0,
  },

  getters: {
    platform: state => {
      if (state.deviceInfo == null || state.deviceInfo.platform === undefined) return null;
      else return state.deviceInfo.platform;
    },

    isNativeApp: (state, getters) => {
      return getters.platform && (getters.platform == "android" || getters.platform == "ios");
    },

    appKey: state => {
      return state.appData?.appKey;
    },

    appName: state => {
      return state.appPackage.name;
    },

    appVersion: state => {
      let verData = state.appPackage.version.split(".");
      let version = {
        version: state.appPackage.version,
        buildNo: parseInt(verData[verData.length - 1]),
      };
      return version;
    },

    appInfo: (state, getters) => {
      return {
        name: getters.appName,
        buildNo: getters.appVersion.buildNo,
        kernelNo: state.kernelNo,
        serverBuildNo: state.serverBuildNo,
      };
    },

    appBuildTimestamp: () => {
      if (document.documentElement.dataset.buildTimestamp) return document.documentElement.dataset.buildTimestamp;
      else return "";
    },

    appReloadAtTimeout: (state, getters) => {
      return getters.appName == "do-order";
    },

    appNoSessionId: (state, getters) => {
      return getters.appName == "do-order";
    },

    apiUrl: () => {
      if (Vue.prototype.$devEnv) return "https://x.mrsdigi.com/do/server/webapp/app.php";
      else if (Vue.prototype.$appMode == APP_MODE.WEB) return "/api";
      else return "https://api.mrsdigi.com/doapi";
    },

    doApiUrl: (state, getters) => {
      return getters.apiUrl + "/order";
    },

    dcApiUrl: (state, getters) => {
      return getters.apiUrl + "/dc";
    },

    stripeApiUrl: (state, getters) => {
      return getters.apiUrl + "/stripe";
    },

    gpApiUrl: (state, getters) => {
      return getters.apiUrl + "/globalpay";
    },

    cloverApiUrl: (state, getters) => {
      return getters.apiUrl + "/clover";
    },

    storageKey: (state, getters) => {
      if (Vue.prototype.$appMode == APP_MODE.APP || Vue.prototype.$appMode == APP_MODE.KIOSK) {
        return state.appToken.CompanyCode;
      } else {
        return getters.storeCompanyCode;
      }
    },

    acceptOrder: state => {
      if (Vue.prototype.$devEnv) return true;

      let n_acceptOrder = true;
      if (state.storeHours) {
        n_acceptOrder = state.storeHours.acceptOrder === true;
      }

      return n_acceptOrder;
    },

    checkOrderLimit: (state, getters) => {
      return (
        getters.orderLimitPerPeriod > 0 &&
        (getters.orderLimitSkipValue == 0 ||
          getters.orderLimitSkipValue >= state.Order.order.subtotal - state.Order.order.discountValue)
      );
    },

    orderHistoryOnCloud: (state, getters) => {
      return getters.memberCode != "";
    },

    orderFrom: (state, getters) => {
      let orderFrom = "";
      if (state.Order.order.orderType == ORDER_TYPE.DINEIN && getters.storeDineinMenuMode) orderFrom = "dinein.menu";
      else if (state.Order.order.tableID > 0 && state.Order.order.tableName != "") {
        orderFrom = state.Order.order.tableName;
      } else if (state.Order.order.tableGroupID > 0 && state.Order.order.tableGroupName != "") {
        orderFrom = state.Order.order.tableGroupName;
      } else {
        orderFrom = state.Order.order.orderType;
      }

      return orderFrom;
    },

    service: state => {
      if (Vue.prototype.$appMode == APP_MODE.APP) {
        return state.service;
      } else {
        if (state.Store.store == null || state.Store.store.service == null) return null;
        else return state.Store.store.service;
      }
    },

    serviceSessionKey: (state, getters) => {
      if (getters.service == null) return null;
      else return getters.service.sessionKey;
    },

    serviceCompanyCode: (state, getters) => {
      if (getters.service == null) return null;
      else return getters.service.companyCode;
    },

    serviceLoginMethods: (state, getters) => {
      let loginMethods = [];
      if (getters.service && getters.service.loginMethods) loginMethods = getters.service.loginMethods;
      return loginMethods;
    },

    loginWithPhone: (state, getters) => {
      return getters.serviceLoginMethods.includes("phoneID");
    },

    loginWithEmail: (state, getters) => {
      return getters.serviceLoginMethods.includes("email");
    },

    checkoutPickupTimeIgnored: (state, getters) => {
      if (!getters.doorDashEnabled && state.Order.order && state.Order.order.orderType && getters.storeOrderTypes) {
        if (state.Order.order.orderType == ORDER_TYPE.DINEIN) {
          return true;
        } else if (state.Order.order.orderType == ORDER_TYPE.TAKEOUT && getters.storeOrderTypes.takeout) {
          if (getters.storeOrderTypes.takeout.pickupTimeIgnored)
            return getters.storeOrderTypes.takeout.pickupTimeIgnored;
          else return false;
        } else if (state.Order.order.orderType == ORDER_TYPE.DELIVERY && getters.storeOrderTypes.delivery) {
          if (getters.storeOrderTypes.delivery.deliveryTimeIgnored)
            return getters.storeOrderTypes.delivery.deliveryTimeIgnored;
          else return false;
        } else return false;
      } else return false;
    },

    doorDashEnabled: (state, getters) => {
      if (state.Order.order?.orderType == ORDER_TYPE.DELIVERY)
        return getters.storeOrderTypes?.delivery?.doorDashEnabled === true;
      else return false;
    },

    ftsTechEnabled: (state, getters) => {
      if (state.Order.order?.orderType == ORDER_TYPE.DELIVERY)
        return getters.storeOrderTypes?.delivery?.ftsTechEnabled === true;
      else return false;
    },

    todayServeTime: state => {
      let _todayServeTime = null;
      if (state.storeHours && state.storeHours) {
        if (state.storeHours.serveTime) {
          _todayServeTime = state.storeHours.serveTime;
        }
      }
      return _todayServeTime;
    },

    languages: (state, getters) => {
      if (Vue.prototype.$appMode == APP_MODE.APP) {
        return state.languages;
      } else {
        let _languages = [];
        if (getters.storeInfo && getters.storeInfo.languages) _languages = getters.storeInfo.languages;

        if (
          Vue.prototype.$appMode == APP_MODE.KIOSK &&
          state.Kiosk?.info?.languages &&
          state.Kiosk.info.languages.length > 0
        )
          _languages = _languages.filter(x => state.Kiosk.info.languages.includes(x.locale));

        return _languages;
      }
    },

    showLangSwitcher: (state, getters) => {
      return getters.languages.length > 1;
    },
  },

  mutations: {
    SET_OFFLINE(state, status) {
      state.isOffline = status;
    },

    theme(state, theme) {
      if (theme == null) return;

      if (theme.primary) {
        state.theme.primary = theme.primary;
      }
      if (theme.secondary) {
        state.theme.secondary = theme.secondary;
      }
      if (theme.accent) {
        state.theme.accent = theme.accent;
      }
      if (theme.info) {
        state.theme.info = theme.info;
      }
      if (theme.success) {
        state.theme.success = theme.success;
      }
      if (theme.warning) {
        state.theme.warning = theme.warning;
      }
      if (theme.error) {
        state.theme.error = theme.error;
      }
      if (theme.primaryText) {
        state.theme.primaryText = theme.primaryText;
      }
      if (theme.secondaryText) {
        state.theme.secondaryText = theme.secondaryText;
      }
      if (theme.accentText) {
        state.theme.accentText = theme.accentText;
      }
      if (theme.infoText) {
        state.theme.infoText = theme.infoText;
      }
      if (theme.warningText) {
        state.theme.warningText = theme.warningText;
      }
    },

    member(state, member) {
      state.member = member;
      mOrder.updateOrderMember();

      let memberCode = state.member?.MemberCode;
      if (state.appData.type == "order") {
        if (state.Store.store) {
          mOrder.updateOrderItemsPrice();
          mOrder.calculateTotal();
        }
        mMember.updateMemberPromos(memberCode);
      }

      if (state.member) {
        let lastLogin = {
          memberCode: memberCode,
          name: "",
          phone1: state.member.PhoneId.substring(2),
          email: state.member.MemberEMail,
          isMember: true,
        };
        mMember.setLastLogin(lastLogin);
      } else mMember.setLastLogin({});
    },

    memberFavoriteStores(state, favoriteStores) {
      state.member.MemberMetadata.FavoriteStores = favoriteStores;
    },
  },

  actions: {},
});
